import { getService } from '../../utils';

export const getGlobalVariablesService = getService('globalVariables');
